









































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import TplDetail from "../../../store/entities/tpls/tpl-detail";
import Address from "../../../store/entities/address";
import AddressModal from "../../components/address-modal.vue";
import _ from "lodash";
import AppConsts from "@/lib/appconst";
Vue.use(require("vue-moment"));

@Component({
  components: { "address-modal": AddressModal },
})
export default class CreateTpl extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  addressModalShow: boolean = false;
  tpl: TplDetail = new TplDetail();
  spinShow: boolean = false;
  selectedAddress: Address = new Address();
  types = [];
  tplType = "";
  numberRegexPattern = AppConsts.numberRegexPattern;
  getTypes() {
    this.$store
      .dispatch({
        type: "tpl/getTypesForSelect",
      })
      .then((result) => {
        this.tplType = result.length === 0 ? "" : result[0].code;
        this.changeType();
        this.types = result;
      });
  }
  changeType() {
    this.tpl.type = this.tplType;
  }
  updateAddress() {
    this.tpl.contactAddress = this.selectedAddress;
    this.tpl.fullAddress = _.isNil(this.selectedAddress)
      ? ""
      : this.selectedAddress.fullAddress;
    this.validatorFullAddress;
  }
  openModalAddress() {
    this.addressModalShow = true;
  }
  async save() {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.CreateTpl"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        this.spinShow = true;
        try {
          await this.$store
            .dispatch({
              type: "tpl/create",
              data: this.tpl,
            })
            .then((result) => {
              Util.showSuccessMsg(this, "Success.CreateTpl");
              this.reset();
              this.onGoBack();
            });
          this.spinShow = false;
        } catch (error) {
          this.spinShow = false;
        }
      },
    });
  }
  onGoBack() {
    this.$root.$router.push({ name: "tpl" });
  }
  reset() {
    this.spinShow = false;
    this.addressModalShow = false;
    this.tpl = new TplDetail();
    this.selectedAddress = new Address();
  }
  created() {
    this.tpl.contactAddress = null;
    this.getTypes();
  }
  validatorFullAddress = (rule: any, value: any, callback: any) => {
    if (
      this.tpl.type === "TPL" &&
      (_.isNil(this.selectedAddress) ||
        _.isEmpty(this.selectedAddress.fullAddress))
    ) {
      callback(
        new Error(
          this.L("Error.RequiredField0", undefined, this.L("FullAddress"))
        )
      );
    } else {
      callback();
    }
  };
}
